"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.systemFactory = void 0;
var models_1 = require("./models");
var detectPlatform = function (navigator) {
    return navigator ? navigator.platform : "";
};
var detectSystem = function (platform) {
    return platform || models_1.System.Unknown;
};
var create = function (navigator) {
    var platform = detectPlatform(navigator);
    return detectSystem(platform);
};
exports.systemFactory = {
    create: create,
};
